<template>
  <div class="my_form">
    <el-dialog
      :title="record.id ? '编辑' : '新增'"
      :visible.sync="visible"
      width="1000px"
      top='20vh'
      :before-close="onClose"
    >
      <el-form :model="form" ref="form" inline>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工程名称:" prop="win_id">
              <el-select v-model="form.win_id" @change="handleChange" filterable>
                  <el-option v-for="item in winList" :key="item.id" :label="item.project_name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建设单位:" prop="construction_unit">
              <el-input v-model="form.construction_unit"  disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目中标经理:" prop="win_project_leader">
              <el-input v-model="form.win_project_leader"  disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中标合同价(万元):" prop="win_contract_price">
              <el-input v-model="form.win_contract_price"  disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中标合同工期:" prop="win_contract_date">
              <el-input v-model="form.win_contract_date"  disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际竣工日期:" prop="actual_acceptance_date">
              <el-date-picker
                v-model="form.actual_acceptance_date"
                type="date"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="送审金额(元):" prop="first_censorship_amount">
              <el-input v-model="form.first_censorship_amount" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终审价(元):" prop="last_instance_amount">
              <el-input v-model="form.last_instance_amount" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终审定价日期:" prop="last_instance_date">
              <el-date-picker v-model="form.last_instance_date" type="date" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审计编号:" prop="audit">
              <el-input v-model="form.audit" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注:" prop="remark">
              <el-input v-model="form.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { IrrigationWorks } from '@/api/datamanagement'
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        project_name: '',
        win_id: '',
        construction_unit: '',
        win_project_leader: '',
        win_contract_price: '',
        win_contract_date: '',
        actual_acceptance_date: '',
        first_censorship_amount: '',
        last_instance_amount: '',
        last_instance_date: '',
        audit: '',
        remark: ''
      },
      winList: [] // 中标项目列表
    };
  },
  watch: {
    visible (val) {
      if (val && this.record.id) {
        this.form = JSON.parse(JSON.stringify(this.record));
        this.handleChange(this.record.win_id)
      } else {
        this.form = {
          project_name: '',
          win_id: '',
          construction_unit: '',
          win_project_leader: '',
          win_contract_price: '',
          win_contract_date: '',
          actual_acceptance_date: '',
          first_censorship_amount: '',
          last_instance_amount: '',
          last_instance_date: '',
          audit: '',
          remark: ''
        }
      }
    }
  },
  created () {
    this.getWind()
  },
  methods: {
    getWind () {
      IrrigationWorks.getWindList(this, {datasourceId: '1630123343430553601'}).then(res => {
        this.winList = res.data.dataList
      })
    },
    handleChange (val) {
      const item = this.winList.find(item => item.id === val)
      this.form.project_name = item.project_name
      this.form.win_project_leader = item.remark
      this.form.win_contract_price = item.price
      this.form.win_contract_date = item.time_limit
      this.form.construction_unit = item.unit
    },
    handleSubmit () {
      const masterData = {
        ...this.form,
        id: this.record.id ? this.record.id : null,
        actual_acceptance_date: dayjs(this.form.actual_acceptance_date).format('YYYY-MM-DD'),
        last_instance_date: dayjs(this.form.last_instance_date).format('YYYY-MM-DD')
      }
      const func = this.record.id ? IrrigationWorks.updateIrrigationWorks : IrrigationWorks.createdIrrigationWorks
      func(this, {datasourceId: '1631134616704258048', masterData}).then(res => {
        this.$message({
          message: this.record.id ? '修改成功' : '添加成功',
          type: 'success'
        });
        this.$emit('submitForm', false);
        this.onClose()
      }).catch(() => {
        this.$message.error(this.record.id ? '修改失败' : '添加失败');
      })
    },
    onClose () {
      this.$emit('update:visible', false);
    },
    onDialogClose () {
      // 还好保留一个遮罩，直接移除
      const tag = document.querySelector('.checkList .v-modal');
      if (tag) tag.remove();
    }
  }
};
</script>

<style lang="scss" scoped>
// :deep(.el-dialog__body) {
//   min-height: 834px;
// }
</style>
